(() => {
  // The custom builder owns choices on this page. Keep Easify active elsewhere.
  if (window.TPOConfigs) window.TPOConfigs.option_sets_searchable = [];
  function init(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const submit = form.querySelector('[data-hiwia-submit]');
    const error = form.querySelector('[data-hiwia-error]');
    const output = form.querySelector('[data-hiwia-total]');
    const feathers = [...form.querySelectorAll('[data-hiwia-feather]')];
    const upgrades = [...form.querySelectorAll('[data-hiwia-upgrade]')];
    const band = form.querySelector('#Hiwia-Band');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:form.dataset.currency || 'USD'});
    const quantityInput = document.querySelector(`input[name="quantity"][form="${form.id}"]`);
    const quantity = () => Math.max(1, parseInt(quantityInput?.value || '1',10));
    const summary = document.createElement('div');
    summary.className = 'hiwia-choice-summary';
    summary.setAttribute('aria-live','polite');
    form.querySelector('.hiwia-build-total').before(summary);
    function update() {
      const checked = feathers.filter(f => f.checked);
      feathers.forEach(f => { f.disabled = checked.length >= 3 && !f.checked; });
      form.querySelector('[data-hiwia-feather-count]').textContent = `${checked.length} of 3 selected`;
      const selected = band.selectedOptions[0];
      const preview = form.querySelector('.hiwia-band-preview');
      preview.hidden = !selected?.dataset.image;
      if (!preview.hidden) {
        const image = preview.querySelector('img');
        image.src = selected.dataset.image;
        image.alt = band.value.startsWith('Band 7 - ') ? 'Band 7, brown leather shown' : band.value;
        preview.querySelector('figcaption').textContent = `${band.value} · ${selected.dataset.width}${band.value === 'Band 7 - Black' ? ' · Brown style shown; black leather selected' : ''}`;
      }
      for (const button of form.querySelectorAll('[data-hiwia-band-choice]')) button.setAttribute('aria-pressed',String(button.dataset.hiwiaBandChoice === band.value));
      const amount = Number(form.dataset.basePrice) + upgrades.reduce((sum,s) => sum + Number(s.selectedOptions[0]?.dataset.price || 0),0);
      output.textContent = money.format(amount * quantity() / 100);
      const card = form.querySelector('[data-hiwia-upgrade="card"]');
      const fields = form.querySelector('[data-hiwia-card-fields]');
      if (fields) fields.hidden = !card?.value;
      const suit = form.querySelector('[data-hiwia-card-suit]');
      if (suit) suit.disabled = form.querySelector('[data-hiwia-card-rank]')?.value === 'Joker';
      const color = form.querySelector('input[name="properties[Hat color]"]:checked')?.value;
      const ribbon = form.querySelector('input[name="properties[Chiffon ribbon]"]:checked')?.value;
      summary.replaceChildren();
      for (const [label,value] of [['Hat',color || 'Choose a color'],['Band',band.value || 'Choose a band'],['Ribbon',ribbon],['Feathers',checked.map(f=>f.value).join(', ') || 'No feathers']]) {
        const p=document.createElement('p');const strong=document.createElement('strong');strong.textContent=`${label}: `;p.append(strong,document.createTextNode(value));summary.append(p);
      }
    }
    form.addEventListener('change',update);
    quantityInput?.addEventListener('change',update);
    for (const button of form.querySelectorAll('[data-hiwia-band-choice]')) button.addEventListener('click',()=>{band.value=button.dataset.hiwiaBandChoice;update();band.focus();});
    let busy = false;
    async function addHat(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || submit.disabled) return;
      error.hidden = true;
      if (!form.reportValidity()) return;
      if (feathers.filter(f=>f.checked).length > 3) { error.textContent='Choose up to 3 included feathers.';error.hidden=false;return; }
      const id = Number(form.querySelector('input[name="id"]').value);
      if (!id) { error.textContent='This hat is currently unavailable.';error.hidden=false;return; }
      const properties = {};
      // Only builder-owned fields are submitted, never hidden fields inserted by an app.
      for (const field of form.querySelectorAll('[data-hiwia-owned]')) {
        if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) continue;
        const match=field.name.match(/^properties\[(.+)\]$/);
        if(match && field.value.trim()) properties[match[1]]=field.value.trim();
      }
      properties['Included feathers']=feathers.filter(f=>f.checked).map(f=>f.value).join(', ') || 'No feathers';
      const build = crypto.randomUUID();
      properties['_Hat build']=build;
      const chosen=upgrades.filter(s=>s.value);
      const cardChoice=form.querySelector('[data-hiwia-card-rank]')?.value;
      const cardName=cardChoice==='Joker' ? 'Joker' : `${cardChoice} of ${form.querySelector('[data-hiwia-card-suit]')?.value}`;
      const items=[{id,quantity:quantity(),properties},...chosen.map(s=>({id:Number(s.value),quantity:quantity(),parent_id:id,properties:{'_Hat build':build,'For custom hat':'Assemble with this hat',...(s.dataset.hiwiaUpgrade==='card'?{'Card':cardName}:{})}}))];
      busy=true;submit.disabled=true;submit.setAttribute('aria-busy','true');
      try {
        const root=window.Shopify?.routes?.root || '/';
        const result=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const body=await result.json();
        if(!result.ok) throw new Error(body.description || body.message || 'Unable to add this hat. Please try again.');
        window.location.assign(`${root}cart`);
      } catch(failure) {
        error.textContent=failure.message;error.hidden=false;busy=false;submit.disabled=false;submit.removeAttribute('aria-busy');
      }
    }
    submit.addEventListener('click',addHat);
    form.addEventListener('submit',addHat,true);
    submit.disabled = false;
    update();
  }
  document.querySelectorAll('[data-hiwia-builder]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hiwia-builder]').forEach(init));
})();

